import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { splitNumberDigits } from 'helpers/math'
import asideModalStore from 'Stores/asideModalStore'
import DataPickerSplit from 'components/ContentBox/Global/DatePicker/DataPickerSplit'
import TypeSelector from './TypeSelector'
import DummyCounter from 'components/ContentBox/Global/Counter/DummyCounter'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import './EmployeeContract.scss'
import { translate as loc, dict } from 'Localisation'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'

const EmployeeContract = () => {
  const {
    changeValue,
    changeValues: changeValuesArray,
    modalValues: getModalValues,
    modalSettings: data,
    check,
  } = asideModalStore
  const astro_hour = 60
  // backend принимает только целые числа, поэтому отправляем только астрономические
  const test_plan_ht_v = [
    { id: 45, name: loc(dict.main_page.text_8) },
    { id: 60, name: loc(dict.main_page.text_9) },
  ]

  const [fields, setFields] = useState({
    salary_amount: data.is_put || data.is_prolong,
    test_plan_mins: getModalValues.test_plan_mins > 0,
    part_time: true,
  })

  const returnValue = (key_name) => {
    if (Object.keys(getModalValues).length) {
      return getModalValues[key_name]
    } else {
      return ''
    }
  }

  const onHourTypeChange = (hourType) => {
    changeValue(0, 'test_plan_mins')
    changeValue(hourType, 'hour_type')
  }

  const changeHandler = (e, key_name) => {
    let value = e.target.value
    changeValue(value, key_name)
  }

  const checkToday = () => {
    if (getModalValues.is_put) {
      let tommorow = new Date()
      tommorow = tommorow.setDate(tommorow.getDate() + 1)
      if (new Date(getModalValues.date_from) < tommorow) {
        return true
      }
    }
    return false
  }

  const getVacationHours = () => getModalValues.vacation_mins / 60 || 0

  const getSalaryAmount = () => {
    const amount = getModalValues.salary_amount || ''
    const arr = amount.split('.')
    //return arr[0].replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
    return splitNumberDigits(arr[0])
  }

  const onChangeSalaryAmount = (e) => {
    const value = e.target.value.replace(/\s/g, '').trim()
    if (/^\d*$/.test(value) && value.length <= 7) {
      changeValue(value, 'salary_amount')
    }
  }

  useEffect(() => {
    const arr = getModalValues

    arr.vacation_days = arr.vacation_days || 1
    arr.vacation_mins = arr.vacation_mins || 60

    if (data.is_prolong) {
      arr.date_from = +arr.date_from.split('-')[0] + 1 + '-01-01'
      arr.date_until = arr.date_from.split('-')[0] + '-12-31'
    }

    changeValuesArray(arr)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const arr = { ...getModalValues }
    if (fields.salary_amount) {
      arr.salary_amount = arr.salary_amount || '0'
      arr.salary_type = arr.salary_type || 1
    } else {
      delete arr.salary_amount
      delete arr.salary_type
    }

    if (fields.test_plan_mins) {
      arr.test_plan_mins = arr.test_plan_mins || 60
      arr.hour_type = arr.hour_type || 60
    } else {
      arr.test_plan_mins = 0
      arr.hour_type = 0
    }

    const finalArr = {
      ...arr,
      part_time: fields.part_time,
      ...(fields.salary_amount && {
        salary_amount: arr.salary_amount,
        salary_type: arr.salary_type,
      }),
      ...(fields.test_plan_mins && {
        test_plan_mins: arr.test_plan_mins,
        hour_type: arr.hour_type,
      }),
    }

    changeValuesArray(finalArr)
    // eslint-disable-next-line
  }, [fields])

  return (
    <div className='modalEmployerContract super-modal__form-column'>
      <FormField>
        <FormLabel isRequired>{loc(dict.main_page.contract_name)}:</FormLabel>
        <FormInput isError={check('title')}>
          {data.is_prolong ? (
            <input
              placeholder={loc(dict.main_page.contract_name)}
              value={getModalValues.title}
              onChange={(e) => changeHandler(e, 'title')}
            />
          ) : (
            <input
              placeholder={loc(dict.main_page.contract_name)}
              value={getModalValues.title || ''}
              onChange={(e) => changeHandler(e, 'title')}
            />
          )}
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel isRequired>
          {loc(dict.main_page.contract_duration)}:
        </FormLabel>
        <DataPickerSplit
          returnValue={returnValue}
          disable_from={checkToday()}
          objectChangeHandler={changeValue}
        />
      </FormField>

      <div className='modalEmployerContract__toggleMainSelectCol'>
        <FormField>
          <ToggleCheckbox
            label={`${loc(dict.main_page.type_salary)}:`}
            checked={fields.salary_amount}
            onChange={() =>
              setFields({ ...fields, salary_amount: !fields.salary_amount })
            }
          />
        </FormField>
        {fields.salary_amount && (
          <FormField>
            <div className='mainSelectorBlock'>
              <TypeSelector
                values={[
                  loc(dict.main_page.monthly),
                  loc(dict.main_page.daily),
                  loc(dict.main_page.hourly),
                ]}
                objectChangeHandler={changeValue}
                selected={getModalValues.salary_type}
                name='salary_type'
              />
              <div className='modalEmployerContract__row2'>
                <FormLabel>{loc(dict.main_page.wage_amount)}:</FormLabel>
                <FormInput>
                  <input
                    placeholder={loc(dict.main_page.text_7)}
                    onChange={onChangeSalaryAmount}
                    value={getSalaryAmount()}
                    className='modalEmployerContract__inputAmount'
                  />
                </FormInput>
              </div>
              <div>
                <p className='modalEmployerContract__link'>
                  {loc(dict.main_page.text_1)}
                </p>
              </div>
            </div>
          </FormField>
        )}
      </div>

      <div className='modalEmployerContract__rowVacation'>
        <FormLabel>{loc(dict.main_page.text_2)}:</FormLabel>
        <DummyCounter
          name='vacation_mins'
          value={getVacationHours()}
          onChange={(val, key) => {
            changeValue(val * 60, key)
          }}
          min={0.5}
          step={0.5}
        />
      </div>

      <div className='modalEmployerContract__rowVacation'>
        <FormLabel>{loc(dict.main_page.text_3)}:</FormLabel>
        <DummyCounter
          name='vacation_days'
          value={+getModalValues.vacation_days || 0}
          onChange={changeValue}
          min={0.5}
          step={0.5}
        />
      </div>

      <div className='modalEmployerContract__toggleMainSelectCol'>
        <FormField>
          <ToggleCheckbox
            label={`${loc(dict.main_page.text_10)}:`}
            checked={fields.test_plan_mins}
            onChange={() =>
              setFields({ ...fields, test_plan_mins: !fields.test_plan_mins })
            }
          />
        </FormField>
        {fields.test_plan_mins && (
          <div className='mainSelectorBlock'>
            <div className='super-modal__form-row2'>
              <FormField>
                <FormLabel>{loc(dict.main_page.text_4)}:</FormLabel>
                <DummyCounter
                  name='test_plan_mins'
                  value={getModalValues.test_plan_mins / astro_hour || 0}
                  onChange={(val, key) => changeValue(val * astro_hour, key)}
                  min={0.5}
                  step={0.5}
                />
              </FormField>
              <FormField>
                <FormLabel>{loc(dict.main_page.text_5)}:</FormLabel>
                <SelectCustom
                  placeholder={loc(dict.main_page.text_5)}
                  options={test_plan_ht_v}
                  valueID={getModalValues.hour_type}
                  onChange={(o) => onHourTypeChange(o.id)}
                />
              </FormField>
            </div>
            <div>
              <p className='modalEmployerContract__link'>
                {loc(dict.main_page.text_6)}
              </p>
            </div>
          </div>
        )}
      </div>

      <FormField>
        <ToggleCheckbox
          label={`Part-time:`}
          checked={fields.part_time}
          onChange={() =>
            setFields({ ...fields, part_time: !fields.part_time })
          }
        />
      </FormField>

      <FormField>
        <FormLabel>{loc(dict.main_page.comment)}:</FormLabel>
        <textarea
          placeholder={loc(dict.main_page.comment)}
          value={getModalValues.comment || ''}
          onChange={(e) => changeHandler(e, 'comment')}
        />
      </FormField>
    </div>
  )
}

export default observer(EmployeeContract)
